<ng-container *ngIf="isShowSearchComponent">
  <div class="app-header">
    <div class="container">
      <p>Add platform, database, managed technologies, and third-party compatibility information for BMC Helix Suites, Solutions, and Products.</p>
    </div>
  </div>
  <div class="search-wrapper">
    <div class="container">
      <ng-template #rt let-r="result" let-t="term">
        <span [innerHTML]="(r.itemVersion ?  r.itemName + ' ' + r.itemVersion  : r.itemName) | highlightMatch: t "
              [title]="r.itemVersion ?  r.itemName + ' ' + r.itemVersion  : r.itemName">
        </span>
        <i [innerHTML]="r.smartNumber ? ' (' + r.smartNumber + ')'   : ''" class="text-secondary"></i>
        <i [innerHTML]="r.itemType === 'PRODUCT_COMPONENT' ? ' (Component)' : ''" class="text-secondary"></i>
      </ng-template>

      <h5>Search for a BMC Helix product</h5>
      <div class="typeahead-wrapper">
        <adapt-rx-typeahead id="main-search"
                            [testID]="'adapt-rx-typeahead-main-search'"
                            [resultStatusMessage]="resultStatusMessage"
                            [(ngModel)]="selectedProduct"
                            [typeahead]="search"
                            [showClearButton]="!isSearchingProducts"
                            [showEmptyResultMessage]="true"
                            [inputFormatter]="inputFormatter"
                            [resultTemplate]="rt"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="15"
                            (onSelectItem)=onSuggestionSelected($event)>
        </adapt-rx-typeahead>

        <div class="sub_label mt-1"><strong>Usage:</strong> LPHDA.21.05.00, BMC Helix Digital Workplace Advanced, etc.</div>

        <div *ngIf="isSearchingProducts; else showSearchIcon"
             class="position-absolute text-info"
             style="z-index: 10; left: 15px; top: 7px">
          <div class="d-icon-circle_75_o animated infinite spin-360 transition-out slow"></div>
        </div>

        <ng-template #showSearchIcon>
          <span class="d-icon-search"></span>
        </ng-template>
      </div>

      <ng-container *ngIf="selectedProduct && searchResults$ | async as searchResults; else showPriorProducts">
        <app-search-result [searchResults]="searchResults"></app-search-result>
      </ng-container>

      <ng-template #showPriorProducts>
        <ng-container *ngIf="!isLoading">
          <app-recently-viewed-products></app-recently-viewed-products>
        </ng-container>
      </ng-template>

      <ng-container *ngIf="isLoading">
        <div style="text-align: center;">
          <div class="loader-container">
            <div class="loader-app"></div>
            <h1 class="loader-app-title">Searching...</h1>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <app-feedback [location]="FEEDBACK_LOCATION.SEARCH"></app-feedback>
</ng-container>
